import { Component, OnInit, ViewChild, ElementRef, Renderer } from '@angular/core';

@Component({
  selector: 'app-create-report',
  templateUrl: './create-report.component.html',
  styleUrls: ['./create-report.component.css']
})
export class CreateReportComponent implements OnInit {
  @ViewChild('searchIconContainer') searchIconContainer: ElementRef;
  @ViewChild('clientSearch') clientSearch: ElementRef;
  @ViewChild('clientSearchBackButton') clientSearchBackButton: ElementRef;
  

  constructor(private renderer: Renderer) { }

  ngOnInit() {
  }
}
